import React from 'react';
import envcompany from 'envcompany';
import './index.less';


//title在白色card内部的布局
class IndexHeader extends React.Component {

    render(){
        return (
            <div className="header">
                <div className="header-container">
                    {envcompany.logoLink}
                    {envcompany.showNavMenu && <ul className="menu">
                        <li><a href="/" title="Face ID"><img className="faceid-logo" src={require('image/logo.png')} /></a></li>
                        <li>
                            <a href="javascript:void(0)" title="Products">Products</a>
                            <div className="sub-menu"><a href="/products/face-verification" title="Face Verification">Face Verification</a><a href="/products/liveness-detection" title="Liveness Detection">Liveness Detection</a><a href="/products/id-card-recognition" title="ID Card Recognition">ID Card Recognition</a></div>
                        </li>
                        <li><a href="javascript:void(0)" title="Technologies">Technologies</a>
                            <div className="sub-menu"><a href="/technology/face-recognition-liveness" title="Face Recognition &amp; Liveness">Face Recognition & Liveness</a><a href="/technology/optical-character-recognition" title="Optical Character Recognition">Optical Character Recognition</a></div>
                        </li>
                        <li><a href="javascript:void(0)" title="Industries">Industries</a>
                            <div className="sub-menu"><a href="/industries/finance" title="Finance">Finance</a><a href="/industries/sharing" title="Sharing Economy">Sharing Economy</a><a href="/industries/social" title="Social &amp; Entertainment">Social & Entertainment</a><a href="/industries/platform" title="Information Service Platform">Information Service Platform</a></div>
                        </li>
                        <li><a href="/about-us" title="About Us">About Us</a></li>
                        <li><a href="/contact-us" title="CONTACT US">Contact Us</a></li>
                    </ul>}
                    {envcompany.documentLink && <ul className="menu">
                        <li><a href={envcompany.documentLink} title="Documentation">Documentation</a></li>
                    </ul>}
                    <ul className="console">
                        <li className="active"><a href="/console/pages" title="Console">Console</a></li>
                        {envcompany.showNavMenu && <li className="chenge-china"><a href={envcompany.languageLink}>中文/EN<span className="earth-white"><img src={require('image/global-white.png')} /></span><span className="earth-blue"><img src={require('image/global-color.png')} /></span></a></li>}
                    </ul>
                </div>
            </div>
        );
    }
};

export default IndexHeader;






// WEBPACK FOOTER //
// ./src/components/IndexHeader/index.js